import { StyleSheet as RNStyleSheet, View } from 'react-native'
import Animated, {
  SharedValue,
  useAnimatedStyle,
  useDerivedValue,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated'

interface Props {
  isExpanded: SharedValue<boolean>
  children: React.ReactNode
  viewKey: string
  style?: any
  duration?: number
}

const AccordionItem = ({
  isExpanded,
  children,
  viewKey,
  style,
  duration = 150,
}: Props) => {
  const height = useSharedValue(0)

  const derivedHeight = useDerivedValue(() =>
    withTiming(height.value * Number(isExpanded.value), {
      duration,
    })
  )

  const derivedOpacity = useDerivedValue(() =>
    withTiming(Number(isExpanded.value), {
      duration,
    })
  )

  const bodyStyle = useAnimatedStyle(() => ({
    height: derivedHeight.value,
    opacity: derivedOpacity.value,
  }))

  return (
    <Animated.View
      key={`accordionItem_${viewKey}`}
      style={[styles.animatedView, bodyStyle, style]}
    >
      <View
        onLayout={(e) => {
          height.value = e.nativeEvent.layout.height
        }}
        style={styles.wrapper}
      >
        {children}
      </View>
    </Animated.View>
  )
}

export default AccordionItem

// Use plain RN StyleSheet instead of unistyles for Animated.View styles,
// since Animated components are 3rd party and can't resolve unistyles proxies on web.
const styles = RNStyleSheet.create({
  animatedView: {
    overflow: 'hidden',
    width: '100%',
  },
  wrapper: {
    alignItems: 'center',
    display: 'flex',
    position: 'absolute',
    width: '100%',
  },
})
